import { EyeSectionProps } from "../interface";
import { AddRow } from "./AddRow";
import { PrescriptionRow } from "./PrescriptionRow";

export const EyeSection = ({
    side,
    lens,
    arabic_name
  }: EyeSectionProps) => (
    <div className="col-12">
      <h3 className="text-center inputs-label m-2 fs-16 fw-600 secondary-color">
        {side}
        <span className="arabic-only"> / {arabic_name}</span>
      </h3>
      <PrescriptionRow
        label="DV"
        lens={lens}
        eye={side === "RIGHT EYE (OD)" ? "r" : "l"}
        view="dv"
        showLabels={true}
      />
      <PrescriptionRow
        label="NV"
        lens={lens}
        eye={side === "RIGHT EYE (OD)" ? "r" : "l"}
        view="nv"
      />
      <AddRow lens={lens} eye={side === "RIGHT EYE (OD)" ? "r" : "l"} />
    </div>
  );